// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__32kph","emails":"CreateEditClinics_emails__15sj6","emailTagLabel":"CreateEditClinics_emailTagLabel__3-loa"};